var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"persistent":"","width":"300"},model:{value:(_vm.load),callback:function ($$v) {_vm.load=$$v},expression:"load"}},[_c('v-card',{attrs:{"color":"primary_dark"}},[_c('v-card-text',[_vm._v(" Processing "),_c('v-progress-linear',{staticClass:"mb-0",attrs:{"indeterminate":_vm.load,"color":"white"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }